import { render, staticRenderFns } from "./AssetValueShareLegend.vue?vue&type=template&id=5ab8d087&"
import script from "./AssetValueShareLegend.vue?vue&type=script&lang=js&"
export * from "./AssetValueShareLegend.vue?vue&type=script&lang=js&"
import style0 from "./AssetValueShareLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports